import charitableContributions from './charitable-contributions.js';
import otherIncome from './other-income.js';
import individualEmploymentIncome from './individual-employment-income.js';

export default [...charitableContributions, ...otherIncome, ...individualEmploymentIncome];
